var swapImgSources = () => {
    if ($(".chanel-banner").length == 0 || ($(".chanel-banner").length > 0 && (String(window.location).indexOf("#") == -1 || String(window.location).indexOf("scrollTo") > -1))) {
        var totalImg = $(".product-img").length,
            loadedImg = 0,
            prodImg = $(".product-img"),
            swatchTag = $(".swatchImgTag");
        prodImg.each(function() {
            $(this).on('load error', function() {
                loadedImg++;
                if (loadedImg == 4 || loadedImg == 8 || loadedImg == 12) {
                    $(window).trigger("resize");
                }
                if (loadedImg == totalImg) {
                    $(window).trigger("resize").promise().then(function() {
                        //  scroll2ProductId();
                    });
                }
            }).attr("src", $(this).data("src"));
        });
        swatchTag.each(function() {
            $(this).attr("src", $(this).data("src"));
        });
    }
};

export {swapImgSources}
